// extracted by css-extract-rspack-plugin
export default {"container":"_e246be68","appliedFilters":"_9297abf9","expandingArea":"_ffcb7ede","moreFiltersButton":"_93d44edf","moreFiltersButtonWrapper":"_c0e5374c"};